module.exports = __webpack_public_path__ + "img/ch_bt_dailycheckin_gif.71f19cf6.png";